<template>
  <footer id="footer" class="mt-auto py-5 bg-dark text-light border-top">
    <div class="container">
      <div class="row">
        <div class="col">Fly Comps</div>
        <div class="col"></div>
        <div class="col"></div>
      </div>
    </div>
  </footer>
</template>
